import { render } from "./EditarCadastro.vue?vue&type=template&id=6f6093c8&scoped=true"
import script from "./EditarCadastro.vue?vue&type=script&lang=js"
export * from "./EditarCadastro.vue?vue&type=script&lang=js"

import "./EditarCadastro.vue?vue&type=style&index=0&id=6f6093c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6093c8"]])

export default __exports__